var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgExploreArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 82,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#explore-arrow_svg__a)",
  d: "M9 1a1 1 0 0 0-2 0h2ZM7.293 81.707a1 1 0 0 0 1.414 0l6.364-6.364a1 1 0 0 0-1.414-1.414L8 79.586l-5.657-5.657A1 1 0 0 0 .93 75.343l6.364 6.364ZM7 1v80h2V1H7Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "explore-arrow_svg__a",
  x1: 8,
  x2: 8,
  y1: 81,
  y2: 1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F0FF14"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F0FF14",
  stopOpacity: 0
})))));
export default SvgExploreArrow;